import React, { useState, useRef, useEffect } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { Link } from 'gatsby';

import { useScrollFreeze } from '@hooks';
import Search from '@svg/search.svg';
import Close from '@svg/close.svg';
import DSOwhite from '@svg/dso-white.svg';

const searchVars = {
  open: {
    opacity: 1,
    transition: {
      duration: 0.5,
      ease: [0.43, 0.13, 0.23, 0.96],
    },
  },
  closed: {
    opacity: 0,
    transition: {
      duration: 0.5,
      ease: [0.43, 0.13, 0.23, 0.96],
    },
  },
};

function handleSubmit(e, linkRef) {
  e.preventDefault();
  linkRef.current.click();
}

function useKeypress(key, action) {
  useEffect(() => {
    function onKeyup(e) {
      if (e.key === key) action();
    }
    window.addEventListener('keyup', onKeyup);
    return () => window.removeEventListener('keyup', onKeyup);
  }, []);
}

const NavInner = ({ toggleSearch }) => {
  useScrollFreeze();
  const [query, setQuery] = useState('');

  const linkRef = useRef(null);

  useKeypress('Escape', () => {
    toggleSearch();
  });

  return (
    <motion.div
      variants={searchVars}
      initial='closed'
      animate='open'
      exit='closed'
      className='z-40 bg-black w-screen h-screen fixed top-0 items-center justify-center grid grid-cols-14'>
      <form
        onSubmit={(e) => handleSubmit(e, linkRef)}
        className='search border-b border-white flex flex-row col-start-2 col-end-14 mx-halfGutter xl:mx-0 xl:col-start-3 xl:col-end-13'>
        <input
          onChange={(e) => setQuery(e.target.value)}
          placeholder='Type to search'
          className='font-medium xl:font-regular text-xl xl:text-6xl leadin-xl xl:leading-6xl h-16 xl:h-32 bg-black text-white w-full focus:outline-none'
        />
        <button type='submit' className='pl-6 xl:pl-12 focus:outline-none'>
          <Search className='w-5 xl:w-10' />
        </button>
      </form>

      <div className='xl:hidden absolute top-2 left-gutter xl:left-halfGutter focus:outline-none'>
        <DSOwhite className='w-24 xl:w-48' />
      </div>

      <button
        onClick={toggleSearch}
        className='xl:hidden absolute top-0 xl:top-5 right-gutter xl:right-halfGutter focus:outline-none'>
        <Close className='w-10 xl:w-16' />
      </button>

      <Link ref={linkRef} to='/search' state={{ searchQuery: query }} />
    </motion.div>
  );
};

export const SearchModal = ({ searchOpen, toggleSearch }) => {
  return (
    <AnimatePresence exitBeforeEnter>
      {searchOpen && <NavInner key={searchOpen} toggleSearch={toggleSearch} />}
    </AnimatePresence>
  );
};
